import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

// Verifique a flag do ambiente e ignore o certificado se estiver em desenvolvimento
if (environment.ignoreSelfSignedCert) {
  console.warn('Ignoring self-signed certificates in development...');
}

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));